import React, {useEffect, useState, useContext} from 'react';
import {Block} from '../block';
import {Typography, Spin, Input, Button} from 'antd';
import {map, cloneDeep} from 'lodash';
import {PlusOutlined, DeleteOutlined} from '@ant-design/icons';
import {OpenApiContext} from '../../openapi-context';

export function ServerBlock({serversData, className, onSave, onCancel}) {
    const [serversArray, setServersArray] = useState();
    const {state, dispatch} = useContext(OpenApiContext);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (serversData && serversData.servers) {
            setServersArray(cloneDeep(serversData.servers));
        }
    }, [serversData]);

    function handleSave() {
        dispatch({type: 'terminate'});
        return onSave && onSave(serversArray);
    }

    function handleCancel() {
        if (serversData && serversData.servers) {
            setServersArray(cloneDeep(serversData.servers));
        }
        dispatch({type: 'terminate'});
        return onCancel && onCancel();
    }

    const triggerEdit = () => dispatch({type: 'activate', message: 'changes to specification server infos'});

    useEffect(() => {
        setIsLoading(false);
    });

    //Add server
    const addServer = () => {
        setIsLoading(true);
        let arrayTemp = serversArray;
        let serverData = {
            url: '',
            description: '',
        };
        arrayTemp.push(serverData);
        setServersArray(arrayTemp);
    };

    //Delete server
    const deleteServer = (key) => {
        setIsLoading(true);
        let arrayTemp = serversArray;
        arrayTemp.splice(key, 1);
        setServersArray(arrayTemp);
    };

    //Save Url
    const saveUrl = (value, key) => {
        serversArray[key].url = value;
        setServersArray(serversArray);
    };

    //Save description
    const saveDescription = (value, key) => {
        serversArray[key].description = value;
        setServersArray(serversArray);
    };

    const ServerEdit = () => {
        return (
            <div className="frontpage">
                <div>
                    {isLoading && <Spin size="large" />}
                    <div className="serverView">
                        <Typography.Title level={2}>Servers</Typography.Title>
                        <Button disabled={false} type="secondary" className="titleIcon" icon={<PlusOutlined />} onClick={addServer} />
                    </div>
                    {serversArray &&
                        map(serversArray, (item, key) => {
                            return (
                                <div style={{marginBottom: 16}} key={key}>
                                    <Input.Group compact size="large" style={{display: 'flex', flexDirection: 'row'}}>
                                        <Input style={{width: '80%'}} defaultValue={item.url} placeholder="Enter Server Url" onChange={(event) => saveUrl(event.target.value, key)} />
                                        <Input
                                            defaultValue={item.description}
                                            onChange={(event) => saveDescription(event.target.value, key)}
                                            addonAfter={<DeleteOutlined onClick={() => deleteServer(key)} />}
                                            style={{width: '30%'}}
                                            placeholder="Name (Optional)"
                                        />
                                    </Input.Group>
                                </div>
                            );
                        })}
                </div>
            </div>
        );
    };

    const ServerView = () => {
        return (
            <div className="frontpage">
                <div>
                    {isLoading && <Spin size="large" />}
                    <div className="serverView">
                        <Typography.Title level={2}>Servers</Typography.Title>
                    </div>
                    {map(serversArray, (item, key) => {
                        return (
                            <div style={{marginBottom: 16}} key={key}>
                                <a href={item.url}>
                                    <p>{item.url || ''}</p>
                                </a>
                                <Typography.Paragraph>{item.description || ''}</Typography.Paragraph>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    return serversData ? (
        <Block className={className} onCancel={handleCancel} onSave={handleSave} onEdit={triggerEdit}>
            {state.editMode ? <ServerEdit /> : <ServerView />}
        </Block>
    ) : null;
}
